import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../layout/fullLayout/loadable/loadable";
import { OOPSError } from "../views/authentication/OopsError";
import { AuthorizedRoute } from "./AuthorizedRoute";
import { ProtectedRoute } from "./ProtectedRoutes";
import { PublicRoute } from "./PublicRoute";
import { BusinessPolicyLayout } from "../views/customers/components/Policies/BusinessPolicy/BusinessPolicyLayout";
import { CommAutomobilePolicyLayout } from "../views/customers/components/Policies/CommAutomobilePolicy/CommAutomobilePolicyLayout";
import { HabitationalPolicyLayout } from "../views/customers/components/Policies/Habitational/HabitationalPolicyLayout";
import { LifeInsuranceBasicDetails } from "../views/customers/components/Policies/LifeInsurance/LifeInsuranceBasicDetails/LifeInsuranceBasicDetails";
import { LifeInsurancePolicyLayout } from "../views/customers/components/Policies/LifeInsurance/LifeInsurancePolicyLayout";
import { LifeInsuranceAdditionalInformationRoot } from "../views/customers/components/Policies/LifeInsurance/AdditionalInformationRoot";
import { AutomobilePolicyLayout } from "../views/customers/components/Policies/AutomobilePolicy/AutmobilePolicyLayout";
import { MODULE_IDS, POLICIES } from "../constants/enums";
import { BusinessTaskActivity } from "../views/customers/components/Policies/BusinessPolicy/TaskActivity/TaskActivity";
import { BusinessNoteFormList } from "../views/customers/components/Policies/BusinessPolicy/BusinessNoteForm/BusinessNoteFormList";
import { CommAutoNoteFormList } from "../views/customers/components/Policies/CommAutomobilePolicy/CommAutoNoteForm/CommAutoNoteFormList";
import { LifeInsuranceNoteFormList } from "../views/customers/components/Policies/LifeInsurance/LifeInsuranceNoteForm/LifeInsuranceNoteFormList";
import { LifeInsuranceCoverageNeed } from "../views/customers/components/Policies/LifeInsurance/LifeInsurancePolicies/CoverageNeed/LifeInsuranceCoverageNeed";
import { LifeInsuranceCoverageNeedList } from "../views/customers/components/Policies/LifeInsurance/LifeInsurancePolicies/CoverageNeed/LifeInsuranceCoverageNeedList";
import { BusinessCancellation } from "../views/customers/components/Policies/BusinessPolicy/BusinessCancellation/BusinessCancellation";
import { LifeInsurancePolicyFormsRoot } from "../views/customers/components/Policies/LifeInsurance/PolicyformRoot";
import { LifeInsuranceCancellation } from "../views/customers/components/Policies/LifeInsurance/LifeInsuranceCancellation/LifeInsuranceCancellation";
import { LifeInsurerClaim } from "../views/customers/components/Policies/LifeInsurance/LifeInsuranceBasicDetails/Claims/Claim";
import { NoPolicyInsuranceReports } from "../views/tasks/InsuranceReports/NoPolicyInsuranceReports/NoPolicyInsuranceReports";
import { ManageTaskNote } from "../views/tasks/TaskNote/ManageTaskNote";
import { CommAutomobileCSIOEDIList } from "../views/customers/components/Policies/CommAutomobilePolicy/CommAutomobileCSIOEDIList/CommAutomobileCSIOEDIList";
import { BillPaymentHistoryView } from "../views/Accounting/Bill/BillPaymentHistoryView";
import { OtherUserLogin } from "../views/authentication/OtherUserLogin";
import { PolicyChange } from "../views/customers/components/Policies/BusinessPolicy/PolicyChange/PolicyChange";
import { PolicyChangeV2 } from "../views/customers/components/Policies/BusinessPolicy/PolicyChange/v2/PolicyChangeV2";
import ThankYou from "../views/Thankyou/Thankyou";
import { fileUploadWithAIRouter } from "../views/FileUploadWithAI/ImportLineSheet.router";
import { policyChangeRequestRoutes } from "../views/tasks/PolicyChangeRequest/policyChangeRequest.router";
import { leadsRoutes } from "../views/leads/Leads.router";
import { g4SignRoutes } from "../views/g4sign/g4sign.router";
import { EmailStatisticsRoutes } from "../views/emailStatistics/EmailStatistics.router";
import { OpportunitesRoutes } from "../views/opportunites/opportunites.router";
import { DashboardRoutes } from "../views/dashboard/Dashboard/Dashboard.router";
import { addressHistoryRoutes } from "../views/customers/components/Policies/Habitational/AddressHistory/AddressHistory.router";
import { insuranceCompanyRoutes } from "../views/insuranceCompany/InsuranceCompany.router";
import { qoutesRoutes } from "../views/Quotes/Quotes.router";
import { eventsRoutes } from "../views/Events/event.router";
import { accountReceivableReports } from "../views/Accounting/AccountReceivable/AccountReceivable.router";
import { AutomobilePolicyFormsRoutes } from "../views/customers/components/Policies/AutomobilePolicy/AutomobilePolicyForms.router";
import { TaxReportsRouter } from "../views/Accounting/TaxReport/TaxReport.router";
import { AccountPayableReportRouter } from "../views/Accounting/AccountPayableReport/AccountPayableReport.router";
import { CommAutomobilePolicyFormsRoutes } from "../views/customers/components/Policies/CommAutomobilePolicy/CommAutomobilePolicy.router";
import { BusinessPolicyFormsRoutes } from "../views/customers/components/Policies/BusinessPolicy/BusinessPolicyForms.router";
import { HabitationalPolicyFormsRoutes } from "../views/customers/components/Policies/Habitational/HabitationalPolicyForms.router";
import { legalRoutes } from "../views/legals/legals.router";
import { appFormRoutes } from "../views/appForm/AppForm.router";
import { equipmentRoutes } from "../views/Equipment/Equipment.router";
import { ProjectRoutes } from "../views/projects/projects.router";
import { UserMappingRoutes } from "../views/user-mapping/userMapping.router";
import { CustomersRoutes } from "../views/customers/Customers.router";
import { automationRoutes } from "../views/automation/automation.router";
import { emailSequencesRoutes } from "../views/emailSequences/emailSequences.router";
import { utilityRoutes } from "../views/settings/utility.router";
import { EnvConfigRoutes } from "../views/EnvConfig/EnvConfig.router";
import { QuoteRoutes } from "../views/QuoteSettings/Quote.router";
import { securityRoutes } from "../views/Security/security.router";
import { TemplatesRoutes } from "../views/Templates/Templates.router";
import { AccountingRoutes } from "../views/Accounting/Accounting.router";
import { ReportsRoutes } from "../views/Reports/Reports.router";
import { ReconciliationRoutes } from "../views/Reconciliation/Reconciliation.router";
import { supportTicketsRoutes } from "../views/supportTickets/supportTickets.router";
import { UsersRoutes } from "../views/Profile/UsersList/Users.router";
import { StaffDirectoryRoutes } from "../views/StaffDirectory/StaffDirectory.router";
import { OnBoardingRoutes } from "../views/OnBoarding/OnBoarding.router";
import { csioCronRoutes } from "../views/csioCron/csioCron.router";
import { CSIORoutes } from "../views/csio/CSIO.router";
import { csioEdocsRoutes } from "../views/csioEdocs/csioEdocs.router";
import { csioEDIRoutes } from "../views/csioEDI/csioEDI.router";
import { taskRoutes } from "../views/tasks/tasks.router";
import { noticesRoutes } from "../views/notices/notices.router";
import { BusinessBasicDetailsRoutes } from "../views/customers/components/Policies/BusinessPolicy/BusinessBasicDetails/BusinessBasicDetails.router";
import { PolicyUnderwritingRoutes } from "../views/customers/components/Policies/BusinessPolicy/PolicyUnderwriting/PolicyUnderwriting.router";
import { BusinessRiskCoverageRoutes } from "../views/customers/components/Policies/BusinessPolicy/BusinessRiskCoverage.router";
import { ClaimRoutes } from "../views/customers/components/Policies/BusinessPolicy/BusinessBasicDetails/Claim/Claim.router";
import { ScheduleRoutes } from "../views/customers/components/Policies/BusinessPolicy/Schedule.router";
import { QuestionnareRoutes } from "../views/customers/components/Policies/BusinessPolicy/Questionnare.router ";
import { AttachmentsRoutes } from "../views/customers/components/Policies/BusinessPolicy/BusinessBasicDetails/Attachment/Attachment.router";
import { MarketingRoutes } from "../views/customers/components/Policies/BusinessPolicy/Marketing.router ";
import { BusinessPremiumFinanceRoutes } from "../views/customers/components/Policies/BusinessPolicy/PremiumFinance/PremiumFinance.router";
import { PolicyChangeRoutes } from "../views/customers/components/Policies/BusinessPolicy/PolicyChange/PolicyChange.router";
import { CSIOEdiRootRoutes } from "../views/customers/components/Policies/BusinessPolicy/CSIOEdiRoot.router ";
import { AllTasksRoutes } from "../views/customers/components/Policies/BusinessPolicy/AllTasks/AllTasks.router";
import { EmailThreadRoutes } from "../views/customers/components/Policies/BusinessPolicy/EmailThread/EmailThread.router";
import { InvoicesRoutes } from "../views/customers/components/Policies/BusinessPolicy/BusinessInvoices/Invoices.router";
import { CommAutomobileRoutes } from "../views/customers/components/Policies/CommAutomobilePolicy/CommAutoBasicDetails/CommAutomobileBasicDetails.router";
import { TaskActivityRoutes } from "../views/customers/components/Policies/BusinessPolicy/TaskActivity/TaskActivity.router";
import { DriverRootRoutes } from "../views/customers/components/Policies/CommAutomobilePolicy/DriverRoot.router";
import { VehicleRootRoutes } from "../views/customers/components/Policies/CommAutomobilePolicy/VehicleRoot.router ";
import { RiskProfileRootRoutes } from "../views/customers/components/Policies/CommAutomobilePolicy/RiskProfile/RiskProfileRoot.router";
import { AutomobileRoutes } from "../views/customers/components/Policies/AutomobilePolicy/AutomobilePolicy.router";
import { HabitationalPolicyRoutes } from "../views/customers/components/Policies/Habitational/Habitational.router";
import { AutomobileEmailThreadRoutes } from "../views/customers/components/Policies/AutomobilePolicy/EmailThread/EmailThread.router";
import { CommAutoEmailThreadRoutes } from "../views/customers/components/Policies/CommAutomobilePolicy/EmailThread/EmailThread.router";
import { HabitationalEmailThreadRoutes } from "../views/customers/components/Policies/Habitational/EmailThread/EmailThread.router";
import { LifeInsuranceEmailThreadRoutes } from "../views/customers/components/Policies/LifeInsurance/EmailThread/EmailThread.router";
import { AutomobileSequencesRoutes } from "../views/customers/components/Policies/AutomobilePolicy/Sequences/Sequences.router";
import { CommAutoSequencesRoutes } from "../views/customers/components/Policies/CommAutomobilePolicy/Sequences/Sequences.router";
import { BusinessSequencesRoutes } from "../views/customers/components/Policies/BusinessPolicy/Sequences/Sequences.router";
import { LifeInsuranceSequencesRoutes } from "../views/customers/components/Policies/LifeInsurance/Sequences/Sequences.router";

import { BusinessG4SignRouter } from "../views/customers/components/Policies/BusinessPolicy/BusinessG4Sign/BusinessG4Sign.router";
import { CommAutoG4SignRouter } from "../views/customers/components/Policies/CommAutomobilePolicy/CommAutoG4Sign/CommAutoG4Sign.router";
import { HabitationalG4SignRouter } from "../views/customers/components/Policies/Habitational/HabitationalG4Sign/HabitationalG4Sign.router";
import { claimsRoutes } from "../views/claims/claims.router";
import { EmailsRoutes } from "../views/emailsHistoryLog/EmailsHistoryLog.router";
import { RIBOFormsRoutes } from "../views/RIBOForms/RIBOForms.router";
import { AutomobilePremiumFinanceRoutes } from "../views/customers/components/Policies/AutomobilePolicy/PremiumFinance/PremiumFinance.router";
import { CommAutoPremiumFinanceRoutes } from "../views/customers/components/Policies/CommAutomobilePolicy/PremiumFinance/PremiumFinance.router";
import { HabitationalPremiumFinanceRoutes } from "../views/customers/components/Policies/Habitational/PremiumFinance/PremiumFinance.router";
import { BusinessCSIOMpoiWrapperRouter } from "../views/customers/components/Policies/BusinessPolicy/BusinessPolicyCSIOMpoi/BusinessPolicyCSIOMpoi.router";
import { CommAutoMpoiWrapperRouter } from "../views/customers/components/Policies/CommAutomobilePolicy/CommAutoCSIOMpoi/CommAutoCSIOMpoi.router";
import { HabitationalCSIOMpoiWrapperRouter } from "../views/customers/components/Policies/Habitational/HabitationalCSIOMpoi/HabitationalCSIOMpoi.router";
import { LifeInsurancePolicyRouter } from "../views/customers/components/Policies/LifeInsurance/LifeInsurancePolicyRouter";
import { ImportBillPaymentsRoutes } from "../views/importBillPayments/importBillPayments.router";
import { followUpsRoutes } from "../views/leads/components/FollowUps/followUps.router";
import { ImportInvoicePaymentsRoutes } from "../views/importInvoicePayments/importInvoicePayment.router";
import { BusinessPolicyUpdatesRoutes } from "../views/customers/components/Policies/BusinessPolicy/BusinessPolicyUpdates/BusinessPolicyUpdates.router";
import { SOVTabRoutes } from "../views/customers/components/Policies/BusinessPolicy/SOVTab/SOVTab.router";
import { BusinessInterruptionTabRoutes } from "../views/customers/components/Policies/BusinessPolicy/BusinessInterruptionTab/BusinessInterruptionTab.router";
import { PublicPolicyUpdatesForm } from "../views/customers/components/Policies/PoliciesCommon/PolicyUpdates/PublicPolicyUpdatesForm";
import { BusinessPolicyLiabilitySlipsRouter } from "../views/customers/components/Policies/BusinessPolicy/BusinessPolicyLiabilitySlips/BusinessPolicyLiabilitySlips.router";
import { AutombilePolicyUpdatesRoutes } from "../views/customers/components/Policies/AutomobilePolicy/AutomobilePolicyUpdates/AutomobilePolicyUpdates.router";
import { HabitationalPolicyUpdatesRoutes } from "../views/customers/components/Policies/Habitational/HabitationalPolicyUpdates/HabitationalPolicyUpdates.router";
import { LifePolicyUpdatesRoutes } from "../views/customers/components/Policies/LifeInsurance/LifePolicyUpdates/LifePolicyUpdates.router";
import { CommAutoPolicyUpdatesRoutes } from "../views/customers/components/Policies/CommAutomobilePolicy/CommAutoPolicyUpdates/CommAutoPolicyUpdates.router";
import { masterDropdownsRoutes } from "../views/MasterDropdowns/MasterDropdowns.router";
import { customFormFieldsRoutes } from "../views/CustomFormFields/CustomFormFields.router";
import { dynamicFormTemplatesRoutes } from "../views/CustomFormFields/DynamicFormTemplates.router";
import { CommAutoActivitiesTabs } from "../views/customers/components/Policies/CommAutomobilePolicy/CommAutoPolicyNotes/CommAutoActivitiesTabs";
import { BusinessActivitiesTabs } from "../views/customers/components/Policies/BusinessPolicy/BusinessPolicyNotes/BusinessActivitiesTabs";
import { myCommissionReportsRoutes } from "../views/Profile/MyCommissionReports/MyCommissionReports.router";
import { myStatementsRoutes } from "../views/Profile/MyStatements/MyStatments.router";
import { policyOptionsRoutes } from "../views/PolicyOptions/PolicyOptions.router";
import { notificationsRoutes } from "../views/Notifications/Notifications.router";
import { emailRoutes } from "../views/email/Email.router";
import { businessCertificateOfInsuranceRouter } from "../views/customers/components/Policies/BusinessPolicy/CertificateofInsurance/CertificateofInsurance.router";
import { automobileCertificateOfInsuranceRouter } from "../views/customers/components/Policies/AutomobilePolicy/AutomobilePolicyForms/AutomobileCertificateofInsurance/CertificateofInsurance.router";
import { commAutoCertificateOfInsuranceRouter } from "../views/customers/components/Policies/CommAutomobilePolicy/CertificateofInsurance/CertificateofInsurance.router";
import { commAutoDriverProfileRouter } from "../views/customers/components/Policies/CommAutomobilePolicy/DriverProfile/DriverProfile.router";
import { HabitationalCertificateOfInsuranceRoutes } from "../views/customers/components/Policies/Habitational/CertificateofInsurance/CertificateofInsurace.router";
import { operationalUpdatesRoutes } from "../views/OperationalUpdates/OperationalUpdates.router";
import { signatureRoutes } from "../views/Signature/Signature.router";
import { accessLogsRoutes } from "../views/settings/accessLogs/accessLogs.router";
import { genAiKnowledgeBaseRoutes } from "../views/documentTraining/DocumentTraining.router";
import { dashboardSettingsRoutes } from "../views/DashboardSettings/PlInsightBenchmark/PlInsightBenchmark.router";
import { phoneRoutes } from "../views/Phone/Phone.router";
import { webrtcDiagnosticsRoutes } from "../views/settings/WebrtcDiagnostics/webrtcDiagnostics.router";
import { whatsAppRoutes } from "../features/WhatsApp/whatsApp.router";
import { genAiRoutes } from "../views/GenAI/genAi.router";
import { MessageSequenceRoutes } from "../views/MessageSequence/MessageSequence.router";
import { externalLeadsRoutes } from "../views/externalLeads";
import { mirtapbxRoutes } from "../views/mirtapbx/mirtapbx.router";
import { isMirtapbxCallLinkingEnabled } from "../helpers/featureFlags";

/* ***Layouts**** */
const FullLayout = Loadable(
  lazy(() =>
    import("../layout/fullLayout/FullLayout").then(({ FullLayout }) => ({
      default: FullLayout,
    })),
  ),
);
const BlankLayout = Loadable(
  lazy(() => import("../layout/blankLayout/BlankLayout")),
);
/* ***End Layouts**** */

const Error = Loadable(
  lazy(() =>
    import("../views/authentication/Error").then(({ Error }) => ({
      default: Error,
    })),
  ),
);

/* ****Pages***** */

const Login = Loadable(
  lazy(() =>
    import("../views/authentication/Login").then(({ Login }) => ({
      default: Login,
    })),
  ),
);
const HrApplication = Loadable(
  lazy(() =>
    import("../views/authentication/HrApplication").then(
      ({ HrApplication }) => ({
        default: HrApplication,
      }),
    ),
  ),
);

const PublicLeadForm = Loadable(
  lazy(() =>
    import("../views/leads/PublicLeadForm/PublicLeadForm").then(
      ({ PublicLeadForm }) => ({
        default: PublicLeadForm,
      }),
    ),
  ),
);

const LeadThankYou = Loadable(
  lazy(() =>
    import("../views/leads/PublicLeadForm/LeadThankYou").then(
      ({ LeadThankYou }) => ({
        default: LeadThankYou,
      }),
    ),
  ),
);

const ForgotPassword = Loadable(
  lazy(() =>
    import("../views/authentication/ForgotPassword").then(
      ({ ForgotPassword }) => ({
        default: ForgotPassword,
      }),
    ),
  ),
);

const AccessDenied = Loadable(
  lazy(() =>
    import("../views/authentication/AccessDenied").then(({ AccessDenied }) => ({
      default: AccessDenied,
    })),
  ),
);

const SubInsurerList = Loadable(
  lazy(() =>
    import("../views/insuranceCompany/SubInsurerList").then(
      ({ SubInsurerList }) => ({
        default: SubInsurerList,
      }),
    ),
  ),
);

const InsurerContactsComposer = Loadable(
  lazy(() =>
    import("../views/insuranceCompany/components/InsurerContacts/InsurerContactsComposer").then(
      ({ InsurerContactsComposer }) => ({
        default: InsurerContactsComposer,
      }),
    ),
  ),
);

const InsurerContactsList = Loadable(
  lazy(() =>
    import("../views/insuranceCompany/InsurerContactsList").then(
      ({ InsurerContactsList }) => ({
        default: InsurerContactsList,
      }),
    ),
  ),
);

const PolicyCommissionList = Loadable(
  lazy(() =>
    import("../views/insuranceCompany/PolicyCommissionList").then(
      ({ PolicyCommissionList }) => ({
        default: PolicyCommissionList,
      }),
    ),
  ),
);

const CsioCompanyList = Loadable(
  lazy(() =>
    import("../views/insuranceCompany/CsioCompanyList").then(
      ({ CsioCompanyList }) => ({
        default: CsioCompanyList,
      }),
    ),
  ),
);

const ViewOpportunites = Loadable(
  lazy(() =>
    import("../views/opportunites/opportunitiesTabs").then(
      ({ OpportunitiesTabs }) => ({
        default: OpportunitiesTabs,
      }),
    ),
  ),
);

const PoliciesList = Loadable(
  lazy(() =>
    import("../views/Policies/PoliciesTabs").then(({ PoliciesTabs }) => ({
      default: PoliciesTabs,
    })),
  ),
);

const BusinessPoliciesList = Loadable(
  lazy(() =>
    import("../views/Policies/BusinessPoliciesList").then(
      ({ BusinessPoliciesList }) => ({
        default: BusinessPoliciesList,
      }),
    ),
  ),
);

const AutomobilePoliciesList = Loadable(
  lazy(() =>
    import("../views/Policies/AutomobilePoliciesList").then(
      ({ AutomobilePoliciesList }) => ({
        default: AutomobilePoliciesList,
      }),
    ),
  ),
);
const LifeAndFinancialPoliciesList = Loadable(
  lazy(() =>
    import("../views/Policies/LifeAndFinancialPoliciesList").then(
      ({ LifeAndFinancialPoliciesList }) => ({
        default: LifeAndFinancialPoliciesList,
      }),
    ),
  ),
);

const CommAutomobilePoliciesList = Loadable(
  lazy(() =>
    import("../views/Policies/CommAutomobilePoliciesList").then(
      ({ CommAutomobilePoliciesList }) => ({
        default: CommAutomobilePoliciesList,
      }),
    ),
  ),
);

const HabitationalPoliciesList = Loadable(
  lazy(() =>
    import("../views/Policies/HabitationalPoliciesList").then(
      ({ HabitationalPoliciesList }) => ({
        default: HabitationalPoliciesList,
      }),
    ),
  ),
);

// COMMERCIAL AUTOMOBILE ROUTING ----------------

//
const CommAutoVehicleInformation = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/CommAutomobilePolicy/CommAutoVehicle/CommAutoVehicleInformation/CommAutoVehicleInformation").then(
      ({ CommAutomobileVehicleInformation }) => ({
        default: CommAutomobileVehicleInformation,
      }),
    ),
  ),
);

const CommAutoAdditionalInformation = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/CommAutomobilePolicy/CommAutoVehicle/CommAutoVehicleAdditional/CommAutoVehicleAdditional").then(
      ({ CommAutomobileAdditionalInformation }) => ({
        default: CommAutomobileAdditionalInformation,
      }),
    ),
  ),
);

const CommAutoInterestedParty = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/CommAutomobilePolicy/CommAutoVehicle/CommAutoVehicleInterested/CommAutoVehicleInterested").then(
      ({ CommAutomobileInterested }) => ({
        default: CommAutomobileInterested,
      }),
    ),
  ),
);

const CommAutomobileAttachmentList = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/CommAutomobilePolicy/CommAutoBasicDetails/Attachment/AttachmentList").then(
      ({ CommAutomobileAttachmentList }) => ({
        default: CommAutomobileAttachmentList,
      }),
    ),
  ),
);

const CommAutomobileLiabilityInsurance = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/CommAutomobilePolicy/CommCSIOCertificate/CommCSIOCertificate").then(
      ({ CommAutoCSIOCertificate }) => ({
        default: CommAutoCSIOCertificate,
      }),
    ),
  ),
);
// const CommAutoSupplementaryFormTab = Loadable(
//   lazy(() =>
//     import(
//       "../views/customers/components/Policies/CommAutomobilePolicy/CommAutoSupplementaryForm/CommAutoSupplementaryTab"
//     ).then(({ CommAutoSupplementaryForm }) => ({
//       default: CommAutoSupplementaryForm,
//     }))
//   )
// );

const CommAutomobileOPCF28A = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/CommAutomobilePolicy/CommAutoOPCF_28/CommAutoOPCF_28").then(
      ({ CommAutoOPCF_28A }) => ({
        default: CommAutoOPCF_28A,
      }),
    ),
  ),
);

// const CommAutomobileGarageApplicationOAF4 = Loadable(
//   lazy(() =>
//     import(
//       "../views/customers/components/Policies/CommAutomobilePolicy/CommAutoInsuranceGarageApplication/CommAutoInsuranceGarageApplication"
//     ).then(({ CommAutomobileInsuranceGarageApplication }) => ({
//       default: CommAutomobileInsuranceGarageApplication,
//     }))
//   )
// );

// --------------- AUTOMOBILE ROUTING ----------------

const AutomobilePolicy = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/AutomobilePolicy/AutomobilePolicy").then(
      ({ AutomobilePolicy }) => ({
        default: AutomobilePolicy,
      }),
    ),
  ),
);

const AutomobileInterested = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/AutomobilePolicy/AutomobileVehicle/AutomobileInterested/AutomobileInterested").then(
      ({ AutomobileInterested }) => ({
        default: AutomobileInterested,
      }),
    ),
  ),
);

const AutomobileAdditional = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/AutomobilePolicy/AutomobileVehicle/AutomobileAdditional/AutomobileAdditional").then(
      ({ AutomobileAdditionalInformation }) => ({
        default: AutomobileAdditionalInformation,
      }),
    ),
  ),
);

const AddressHistory = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/Habitational/AddressHistory/AddressHistoryList").then(
      ({ AddressHistoryList }) => ({
        default: AddressHistoryList,
      }),
    ),
  ),
);

// -----------------------------------------------TASK ---------------------------------------
const CreateTasks = Loadable(
  lazy(() =>
    import("../views/tasks/task").then(({ Task }) => ({
      default: Task,
    })),
  ),
);

const NewTaskNotesList = Loadable(
  lazy(() =>
    import("../views/tasks/TaskNote/NewTaskNotesList").then(
      ({ NewTaskNotesList }) => ({
        default: NewTaskNotesList,
      }),
    ),
  ),
);
const TaskApprovalList = Loadable(
  lazy(() =>
    import("../views/tasks/TaskNote/TaskApprovalList").then(
      ({ TaskApprovalList }) => ({
        default: TaskApprovalList,
      }),
    ),
  ),
);
const InsuranceReport = Loadable(
  lazy(() =>
    import("../views/tasks/InsuranceReports/InsuranceReportLIst").then(
      ({ InsuranceReport }) => ({
        default: InsuranceReport,
      }),
    ),
  ),
);
const OrderInsuranceReport = Loadable(
  lazy(() =>
    import("../views/tasks/InsuranceReports/OrderInsuranceReport").then(
      ({ OrderInsuranceReport }) => ({
        default: OrderInsuranceReport,
      }),
    ),
  ),
);
const ViewProfile = Loadable(
  lazy(() =>
    import("../views/Profile/ViewProfile/ViewProfile").then(
      ({ ViewProfile }) => ({
        default: ViewProfile,
      }),
    ),
  ),
);

const BusinessActivityList = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/BusinessPolicy/BusinessBasicDetails/BusinessTask/BusinessTaskList").then(
      ({ BusinessActivityList }) => ({
        default: BusinessActivityList,
      }),
    ),
  ),
);

const OPCF_17 = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/AutomobilePolicy/OPCF_17/OPCF_17").then(
      ({ OPCF_17 }) => ({ default: OPCF_17 }),
    ),
  ),
);

const DecodeVin = Loadable(
  lazy(() =>
    import("../views/decodeVin/DecodeVin").then(({ DecodeVin }) => ({
      default: DecodeVin,
    })),
  ),
);

const SecurityDashboard = Loadable(
  lazy(() =>
    import("../views/Security/CreateSecurityGroup").then(
      ({ CreateSecurityGroup }) => ({ default: CreateSecurityGroup }),
    ),
  ),
);

const ViewInsurerContact = Loadable(
  lazy(() =>
    import("../views/insuranceCompany/components/ViewsBrokerage/ViewInsurerContact").then(
      ({ ViewInsurerContact }) => ({ default: ViewInsurerContact }),
    ),
  ),
);
const ViewInsurerSubTable = Loadable(
  lazy(() =>
    import("../views/insuranceCompany/components/ViewsBrokerage/ViewInsurerSubTable").then(
      ({ ViewInsurerSubTable }) => ({ default: ViewInsurerSubTable }),
    ),
  ),
);
const ViewPolicyCommission = Loadable(
  lazy(() =>
    import("../views/insuranceCompany/components/ViewsBrokerage/ViewPolicyCommission").then(
      ({ ViewPolicyCommission }) => ({ default: ViewPolicyCommission }),
    ),
  ),
);
const ViewUnderWriter = Loadable(
  lazy(() =>
    import("../views/insuranceCompany/components/ViewsBrokerage/ViewUnderWriter").then(
      ({ ViewUnderWriter }) => ({ default: ViewUnderWriter }),
    ),
  ),
);
const ViewInsurer = Loadable(
  lazy(() =>
    import("../views/insuranceCompany/components/ViewsBrokerage/ViewInsurer").then(
      ({ ViewInsurer }) => ({ default: ViewInsurer }),
    ),
  ),
);
const ViewCSIOCompany = Loadable(
  lazy(() =>
    import("../views/insuranceCompany/components/ViewsBrokerage/ViewCSIOCompany").then(
      ({ ViewCSIOCompany }) => ({ default: ViewCSIOCompany }),
    ),
  ),
);
const ViewBrokerCode = Loadable(
  lazy(() =>
    import("../views/insuranceCompany/components/ViewsBrokerage/ViewBrokerCode").then(
      ({ ViewBrokerCode }) => ({ default: ViewBrokerCode }),
    ),
  ),
);
const ViewBranchOffice = Loadable(
  lazy(() =>
    import("../views/insuranceCompany/components/ViewsBrokerage/ViewBranchOffice").then(
      ({ ViewBranchOffice }) => ({ default: ViewBranchOffice }),
    ),
  ),
);

const ViewTaskStep1 = Loadable(
  lazy(() =>
    import("../views/tasks/ViewTask/ViewTaskStep1").then(
      ({ ViewTaskStep_1 }) => ({ default: ViewTaskStep_1 }),
    ),
  ),
);

const ViewInsurerReport = Loadable(
  lazy(() =>
    import("../views/tasks/ViewTask/ViewInsurerReport").then(
      ({ ViewInsurerReport }) => ({ default: ViewInsurerReport }),
    ),
  ),
);

const ViewInsurerContactList = Loadable(
  lazy(() =>
    import("../views/insuranceCompany/InsurerContactsList").then(
      ({ InsurerContactsList }) => ({ default: InsurerContactsList }),
    ),
  ),
);

const CreateOpportunites = Loadable(
  lazy(() =>
    import("../views/opportunites/ManageOpportunityTabs").then(
      ({ ManageOpportunityTabs }) => ({ default: ManageOpportunityTabs }),
    ),
  ),
);

const HabitationalMortgagee = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/Habitational/habitationalMortgagee/habitationalMortgagee").then(
      ({ MortgageeLossPayee }) => ({
        default: MortgageeLossPayee,
      }),
    ),
  ),
);
const AccountingRecievable = Loadable(
  lazy(() =>
    import("../views/Accounting/Recievable/Recievable/Recievable").then(
      ({ AccountingRecievable }) => ({
        default: AccountingRecievable,
      }),
    ),
  ),
);

const AccountingRecievableTrust = Loadable(
  lazy(() =>
    import("../views/Accounting/Recievable/RecievableTrust/RecievableTrust").then(
      ({ RecievableTrust }) => ({
        default: RecievableTrust,
      }),
    ),
  ),
);

const AccountingRecievableTabs = Loadable(
  lazy(() =>
    import("../views/Accounting/Recievable/RecievableTabs").then(
      ({ AccountingRecievableTabs }) => ({
        default: AccountingRecievableTabs,
      }),
    ),
  ),
);

const AccountingEft = Loadable(
  lazy(() =>
    import("../views/Accounting/Payment/Eft/Eft").then(({ AccountingEft }) => ({
      default: AccountingEft,
    })),
  ),
);

const AccountingAccountPayable = Loadable(
  lazy(() =>
    import("../views/Accounting/Payment/AccountPayable/AccountPayable").then(
      ({ AccountPayable }) => ({
        default: AccountPayable,
      }),
    ),
  ),
);

const AccountingInteracEmailTransfer = Loadable(
  lazy(() =>
    import("../views/Accounting/Payment/InteracEmailTransfer/InteracEmailTransfer").then(
      ({ InteracEmailTransfer }) => ({
        default: InteracEmailTransfer,
      }),
    ),
  ),
);

const AccountingTransactions = Loadable(
  lazy(() =>
    import("../views/Accounting/Transactions/Transactions").then(
      ({ AccountingTransactions }) => ({
        default: AccountingTransactions,
      }),
    ),
  ),
);

const AccountingTransactionList = Loadable(
  lazy(() =>
    import("../views/Accounting/Transactions/TransactionList").then(
      ({ AccountingTransactionList }) => ({
        default: AccountingTransactionList,
      }),
    ),
  ),
);

const AccountingInformation = Loadable(
  lazy(() =>
    import("../views/Accounting/AccountingInformation/AccountingInformation").then(
      ({ AccountingInformation }) => ({
        default: AccountingInformation,
      }),
    ),
  ),
);

const AccountingInformationList = Loadable(
  lazy(() =>
    import("../views/Accounting/AccountingInformation/AccountingInformationList").then(
      ({ AccountingInformationList }) => ({
        default: AccountingInformationList,
      }),
    ),
  ),
);

const CallBillAgencyorDirectList = Loadable(
  lazy(() =>
    import("../views/Accounting/CalBillAgencyorDirect/CallBillAgencyorDirectList").then(
      ({ CallBillAgencyorDirectList }) => ({
        default: CallBillAgencyorDirectList,
      }),
    ),
  ),
);

const AccountingPaymentTabs = Loadable(
  lazy(() =>
    import("../views/Accounting/Payment/PaymentTab").then(
      ({ AccountingPaymentsTabs }) => ({
        default: AccountingPaymentsTabs,
      }),
    ),
  ),
);
const HabitationalAddressHistory = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/Habitational/HabitationalAddressHistory/HabitationalAddressHistory").then(
      ({ HabitationalAddressHistory }) => ({
        default: HabitationalAddressHistory,
      }),
    ),
  ),
);

const HabitationalLiabilityExtensionExclusion = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/Habitational/HabitationalLiabilityExtension/HabitationalLiabilityExtension").then(
      ({ HabitationalLiabilityExtensionExclusion }) => ({
        default: HabitationalLiabilityExtensionExclusion,
      }),
    ),
  ),
);

const HabitationalDiscountSurcharges = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/Habitational/HabitationalDiscountSurcharges/HabitationalDiscountSurcharges").then(
      ({ HabitationalDiscountSurcharges }) => ({
        default: HabitationalDiscountSurcharges,
      }),
    ),
  ),
);

const HabitationalPremiumInformation = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/Habitational/HabitationalPremiumInformation/HabitationalPremiumInformation").then(
      ({ HabitationalPremiumInformation }) => ({
        default: HabitationalPremiumInformation,
      }),
    ),
  ),
);

const LifeInsuranceComplianceCheckList = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/LifeInsurance/LifeInsurancePolicies/ComplieanceChecklist/ComplieanceChecklist").then(
      ({ LifeInsuranceComplianceCheckList }) => ({
        default: LifeInsuranceComplianceCheckList,
      }),
    ),
  ),
);

const LifeInsuranceTaskActivity = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/LifeInsurance/TaskActivity/TaskActivity").then(
      ({ LifeFinancialTaskActivity }) => ({
        default: LifeFinancialTaskActivity,
      }),
    ),
  ),
);

const LifeInsuranceFamilyTreeExistingList = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/LifeInsurance/LifeInsuranceAdditionalInformation/FamilyTreeExisting/FamilyTreeList").then(
      ({ LifeInsuranceFamilyTreeList }) => ({
        default: LifeInsuranceFamilyTreeList,
      }),
    ),
  ),
);

const LifeInsuranceFamilyTreeExisting = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/LifeInsurance/LifeInsuranceAdditionalInformation/FamilyTreeExisting/FamilyTreeExisting").then(
      ({ LifeInsuranceFamilyTreeExisting }) => ({
        default: LifeInsuranceFamilyTreeExisting,
      }),
    ),
  ),
);

//-----------NOTICES-------------

const PolicyNotesList = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/Notes/NotesList").then(
      ({ NotesList }) => ({
        default: NotesList,
      }),
    ),
  ),
);

const BusinessPolicyNoteForm = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/BusinessPolicy/BusinessNoteForm/BusinessNoteForm").then(
      ({ BusinessNoteForm }) => ({
        default: BusinessNoteForm,
      }),
    ),
  ),
);
const CommAutoPolicyNoteForm = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/CommAutomobilePolicy/CommAutoNoteForm/CommAutoNoteForm").then(
      ({ CommAutoNoteForm }) => ({
        default: CommAutoNoteForm,
      }),
    ),
  ),
);

const LifeInsurancePolicyNoteForm = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/LifeInsurance/LifeInsuranceNoteForm/LifeInsuranceNoteForm").then(
      ({ LifeInsuranceNoteForm }) => ({
        default: LifeInsuranceNoteForm,
      }),
    ),
  ),
);

const LifeInsuranceHistory = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/LifeInsurance/LifeInsuranceBasicDetails/LifeInsuranceHistory/LifeInsuranceHistory").then(
      ({ LifeInsuranceHistory }) => ({
        default: LifeInsuranceHistory,
      }),
    ),
  ),
);
const LifeInsuranceAttachmentList = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/LifeInsurance/LifeInsuranceBasicDetails/Attachment/AttachmentList").then(
      ({ LifeInsuranceAttachmentList }) => ({
        default: LifeInsuranceAttachmentList,
      }),
    ),
  ),
);

const LifeInsuranceTask = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/LifeInsurance/LifeInsuranceBasicDetails/LifeInsuranceTask/LifeInsuranceTask").then(
      ({ LifeInsuranceTask }) => ({
        default: LifeInsuranceTask,
      }),
    ),
  ),
);

const PremiumFinanceForTaskTab = Loadable(
  lazy(() =>
    import("../views/customers/components/Policies/PoliciesCommon/PremiumFinanceList/PremiumFinanceForTaskTab").then(
      ({ PremiumFinanceForTaskTab }) => ({
        default: PremiumFinanceForTaskTab,
      }),
    ),
  ),
);

const ManageCSIO = Loadable(
  lazy(() =>
    import("../views/csio/ManageCSIO").then(({ ManageCSIO }) => ({
      default: ManageCSIO,
    })),
  ),
);

/* ****Routes***** */

export const Router = [
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <FullLayout />
      </ProtectedRoute>
    ),
    children: [
      // ------------- Insurer Route ----------------------------

      // ------------- Sub Insurer Route ----------------------------

      {
        path: "/sub-insurer",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.INSURER_SUB]}>
            <SubInsurerList />
          </AuthorizedRoute>
        ),
      },

      // ------------- Insurer Contact Route ----------------------------

      {
        path: "/insurer-contacts-composer",
        children: [
          {
            path: "/insurer-contacts-composer/",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.INSURER_CONTACTS]}>
                <InsurerContactsComposer />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/insurer-contacts-composer/:id",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.INSURER_CONTACTS]}>
                <InsurerContactsComposer />
              </AuthorizedRoute>
            ),
          },
        ],
      },
      {
        path: "/insurer-contacts",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.INSURER_CONTACTS]}>
            <InsurerContactsList />
          </AuthorizedRoute>
        ),
      },

      // ------------- CSIO Company ----------------------------

      {
        path: "/csio-company",
        exact: true,
        element: (
          <AuthorizedRoute
            allowFullAccess
            moduleKeys={[MODULE_IDS.CSIO_COMPANY]}
          >
            <CsioCompanyList />
          </AuthorizedRoute>
        ),
      },

      // ------------- Policy Commission Company ----------------------------

      {
        path: "/policy-commission",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.POLICY_COMISSION]}>
            <PolicyCommissionList />
          </AuthorizedRoute>
        ),
      },

      {
        path: "/all-policies",
        exact: true,
        element: (
          <AuthorizedRoute
            moduleKeys={[
              MODULE_IDS.ALL_POLICY,
              MODULE_IDS.BUSINESS_POLICY,
              MODULE_IDS.COMMERCIAL_AUTO,
              MODULE_IDS.AUTOMOBILE,
              MODULE_IDS.HABITATIONAL,
              MODULE_IDS.LIFE_AND_FINCANCIAL,
            ]}
          >
            <PoliciesList />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/policies/business-policies",
        exact: true,
        element: (
          <AuthorizedRoute
            moduleKeys={[
              MODULE_IDS.ALL_POLICY,
              MODULE_IDS.BUSINESS_POLICY,
              MODULE_IDS.COMMERCIAL_AUTO,
              MODULE_IDS.AUTOMOBILE,
              MODULE_IDS.HABITATIONAL,
              MODULE_IDS.LIFE_AND_FINCANCIAL,
            ]}
          >
            <BusinessPoliciesList />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/policies/automobile-policies",
        exact: true,
        element: (
          <AuthorizedRoute
            moduleKeys={[
              MODULE_IDS.ALL_POLICY,
              MODULE_IDS.BUSINESS_POLICY,
              MODULE_IDS.COMMERCIAL_AUTO,
              MODULE_IDS.AUTOMOBILE,
              MODULE_IDS.HABITATIONAL,
              MODULE_IDS.LIFE_AND_FINCANCIAL,
            ]}
          >
            <AutomobilePoliciesList />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/policies/life-and-financial-policies",
        exact: true,
        element: (
          <AuthorizedRoute
            moduleKeys={[
              MODULE_IDS.ALL_POLICY,
              MODULE_IDS.BUSINESS_POLICY,
              MODULE_IDS.COMMERCIAL_AUTO,
              MODULE_IDS.AUTOMOBILE,
              MODULE_IDS.HABITATIONAL,
              MODULE_IDS.LIFE_AND_FINCANCIAL,
            ]}
          >
            <LifeAndFinancialPoliciesList />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/policies/commercial-auto-policies",
        exact: true,
        element: (
          <AuthorizedRoute
            moduleKeys={[
              MODULE_IDS.ALL_POLICY,
              MODULE_IDS.BUSINESS_POLICY,
              MODULE_IDS.COMMERCIAL_AUTO,
              MODULE_IDS.AUTOMOBILE,
              MODULE_IDS.HABITATIONAL,
              MODULE_IDS.LIFE_AND_FINCANCIAL,
            ]}
          >
            <CommAutomobilePoliciesList />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/policies/habitational-policies",
        exact: true,
        element: (
          <AuthorizedRoute
            moduleKeys={[
              MODULE_IDS.ALL_POLICY,
              MODULE_IDS.BUSINESS_POLICY,
              MODULE_IDS.COMMERCIAL_AUTO,
              MODULE_IDS.AUTOMOBILE,
              MODULE_IDS.HABITATIONAL,
              MODULE_IDS.LIFE_AND_FINCANCIAL,
            ]}
          >
            <HabitationalPoliciesList />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/policies/:line_of_business",
        exact: true,
        element: (
          <AuthorizedRoute
            moduleKeys={[
              MODULE_IDS.ALL_POLICY,
              MODULE_IDS.BUSINESS_POLICY,
              MODULE_IDS.COMMERCIAL_AUTO,
              MODULE_IDS.AUTOMOBILE,
              MODULE_IDS.HABITATIONAL,
              MODULE_IDS.LIFE_AND_FINCANCIAL,
            ]}
          >
            <PoliciesList />
          </AuthorizedRoute>
        ),
      },

      /*------*/
      {
        path: "/business-policy/:customerId",
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
            <BusinessPolicyLayout />
          </AuthorizedRoute>
        ),
        children: [
          {
            path: "/business-policy/:customerId/policy-change-request/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                <PolicyChange />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/business-policy/:customerId/policy-change-request/:customerPolicyId/manage/:incrementalNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                <PolicyChange />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/business-policy/:customerId/policy-change-request-v2/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                <PolicyChangeV2 />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/business-policy/:customerId/policy-change-request-v2/:customerPolicyId/manage/:incrementalNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                <PolicyChangeV2 />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/business-policy/:customerId/policy-forms-tab/:customerPolicyId/cancellation/:taskCode",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                <BusinessCancellation />
              </AuthorizedRoute>
            ),
          },

          {
            path: "/business-policy/:customerId/policy-notes-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                <BusinessActivitiesTabs />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/business-policy/:customerId/notes-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                <BusinessNoteFormList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/business-policy/:customerId/notes-tab/:customerPolicyId/note",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                <BusinessPolicyNoteForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/business-policy/:customerId/notes-tab/:customerPolicyId/note/:noteNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                <BusinessPolicyNoteForm />
              </AuthorizedRoute>
            ),
          },

          {
            path: "/business-policy/:customerId/history-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                <BusinessActivityList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/business-policy/:customerId/history-tab/:customerPolicyId/history/:taskNumber",
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                <BusinessActivityList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/business-policy/:customerId/task-activity-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                <BusinessTaskActivity />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/business-policy/:customerId/task-activity-tab/:customerPolicyId/tasks",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.ALL_TASK]}>
                <CreateTasks fromPolicy policyType={POLICIES.BUSINESS_POLICY} />
              </AuthorizedRoute>
            ),
          },

          {
            path: "/business-policy/:customerId/task-activity-tab/:customerPolicyId/tasks/:taskCode",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.ALL_TASK]}>
                <CreateTasks fromPolicy policyType={POLICIES.BUSINESS_POLICY} />
              </AuthorizedRoute>
            ),
          },
        ]
          .concat(BusinessPolicyFormsRoutes)
          .concat(BusinessBasicDetailsRoutes)
          .concat(PolicyUnderwritingRoutes)
          .concat(BusinessRiskCoverageRoutes)
          .concat(ClaimRoutes)
          .concat(ScheduleRoutes)
          .concat(QuestionnareRoutes)
          .concat(AttachmentsRoutes)
          .concat(MarketingRoutes)
          .concat(PolicyChangeRoutes)
          .concat(CSIOEdiRootRoutes)
          .concat(AllTasksRoutes)
          .concat(EmailThreadRoutes)
          .concat(BusinessSequencesRoutes)
          .concat(InvoicesRoutes)
          .concat(TaskActivityRoutes)
          .concat(BusinessG4SignRouter)
          .concat(BusinessPremiumFinanceRoutes)
          .concat(BusinessCSIOMpoiWrapperRouter)
          .concat(BusinessPolicyUpdatesRoutes)
          .concat(BusinessPolicyLiabilitySlipsRouter)
          .concat(BusinessPolicyFormsRoutes)
          .concat(businessCertificateOfInsuranceRouter)
          .concat(SOVTabRoutes)
          .concat(BusinessInterruptionTabRoutes),
      },

      // COMMERCIAL AUTO ROUTING---------------------------
      {
        path: "/comm-automobile-policy/:customerId",
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
            <CommAutomobilePolicyLayout />
          </AuthorizedRoute>
        ),
        children: [
          {
            path: "/comm-automobile-policy/:customerId/csio-edi-list/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
                <CommAutomobileCSIOEDIList />
              </AuthorizedRoute>
            ),
          },
          // {
          //   path: "/comm-automobile-policy/:customerId/application-tab/:customerPolicyId/garage",
          //   exact: true,
          //   element: (
          //     <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
          //       <CommAutomobileGarageApplicationOAF4 />
          //     </AuthorizedRoute>
          //   ),
          // },
          // {
          //   path: "/comm-automobile-policy/:customerId/application-tab/:customerPolicyId/garage/:garageNumber",
          //   exact: true,
          //   element: (
          //     <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
          //       <CommAutomobileGarageApplicationOAF4 />
          //     </AuthorizedRoute>
          //   ),
          // },

          {
            path: "/comm-automobile-policy/:customerId/policy-notes/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
                {/* <CommAutoPolicyFormsRoot /> */}
                <CommAutoActivitiesTabs />
              </AuthorizedRoute>
            ),
          },

          // {
          //   path: "/comm-automobile-policy/:customerId/application-tab/:customerPolicyId/garage-supplement",
          //   exact: true,
          //   element: (
          //     <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
          //       <CommAutoSupplementaryFormTab />
          //     </AuthorizedRoute>
          //   ),
          // },
          // {
          //   path: "/comm-automobile-policy/:customerId/application-tab/:customerPolicyId/garage-supplement/:serialNumber",
          //   exact: true,
          //   element: (
          //     <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
          //       <CommAutoSupplementaryFormTab />
          //     </AuthorizedRoute>
          //   ),
          // },

          {
            path: "/comm-automobile-policy/:customerId/attachments-tab/:customerPolicyId",
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
                <CommAutomobileAttachmentList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/comm-automobile-policy/:customerId/notes-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
                <CommAutoNoteFormList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/comm-automobile-policy/:customerId/notes-tab/:customerPolicyId/note",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
                <CommAutoPolicyNoteForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/comm-automobile-policy/:customerId/notes-tab/:customerPolicyId/note/:noteNumber",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
                <CommAutoPolicyNoteForm />
              </AuthorizedRoute>
            ),
          },

          {
            path: "/comm-automobile-policy/:customerId/task-activity-tab/:customerPolicyId/tasks",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.ALL_TASK]}>
                <CreateTasks
                  fromPolicy
                  policyType={POLICIES.COMMERCIAL_AUTO_POLICY}
                />
              </AuthorizedRoute>
            ),
          },

          {
            path: "/comm-automobile-policy/:customerId/task-activity-tab/:customerPolicyId/tasks/:taskCode",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.ALL_TASK]}>
                <CreateTasks
                  fromPolicy
                  policyType={POLICIES.COMMERCIAL_AUTO_POLICY}
                />
              </AuthorizedRoute>
            ),
          },
        ]
          .concat(CommAutomobilePolicyFormsRoutes)
          .concat(DriverRootRoutes)
          .concat(VehicleRootRoutes)
          .concat(RiskProfileRootRoutes)
          .concat(CommAutoG4SignRouter)
          .concat(CommAutomobileRoutes)
          .concat(CommAutoPremiumFinanceRoutes)
          .concat(CommAutoMpoiWrapperRouter)
          .concat(CommAutoPolicyUpdatesRoutes)
          .concat(CommAutoEmailThreadRoutes)
          .concat(CommAutoSequencesRoutes)
          .concat(commAutoCertificateOfInsuranceRouter)
          .concat(commAutoDriverProfileRouter),
      },

      // AUTOMOBILE ROUTING---------------------------
      {
        path: "/automobile-policy/:customerId",
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
            <AutomobilePolicyLayout />
          </AuthorizedRoute>
        ),
        children: [
          {
            path: "/automobile-policy/:customerId/task-activity-tab/:customerPolicyId/tasks",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.ALL_TASK]}>
                <CreateTasks
                  fromPolicy
                  policyType={POLICIES.AUTOMOBILE_POLICY}
                />
              </AuthorizedRoute>
            ),
          },

          {
            path: "/automobile-policy/:customerId/task-activity-tab/:customerPolicyId/tasks/:taskCode",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.ALL_TASK]}>
                <CreateTasks
                  fromPolicy
                  policyType={POLICIES.AUTOMOBILE_POLICY}
                />
              </AuthorizedRoute>
            ),
          },
        ]
          .concat(AutomobilePolicyFormsRoutes)
          .concat(AutomobileRoutes)
          .concat(AutomobilePremiumFinanceRoutes)
          .concat(AutombilePolicyUpdatesRoutes)
          .concat(AutomobileEmailThreadRoutes)
          .concat(AutomobileSequencesRoutes)
          .concat(automobileCertificateOfInsuranceRouter),
      },

      // HABITATIONAL POLICY

      {
        path: "/habitational-policy/:customerId",
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
            <HabitationalPolicyLayout />
          </AuthorizedRoute>
        ),
        children: [
          {
            path: "/habitational-policy/:customerId/task-activity-tab/:customerPolicyId/tasks",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.ALL_TASK]}>
                <CreateTasks
                  fromPolicy
                  policyType={POLICIES.HABITATIONAL_POLICY}
                />
              </AuthorizedRoute>
            ),
          },

          {
            path: "/habitational-policy/:customerId/task-activity-tab/:customerPolicyId/tasks/:taskCode",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.ALL_TASK]}>
                <CreateTasks
                  fromPolicy
                  policyType={POLICIES.HABITATIONAL_POLICY}
                />
              </AuthorizedRoute>
            ),
          },
        ]
          .concat(addressHistoryRoutes)
          .concat(HabitationalPolicyRoutes)
          .concat(HabitationalG4SignRouter)
          .concat(HabitationalPolicyFormsRoutes)
          .concat(HabitationalCSIOMpoiWrapperRouter)
          .concat(HabitationalPremiumFinanceRoutes)
          .concat(HabitationalPolicyUpdatesRoutes)
          .concat(HabitationalEmailThreadRoutes)
          .concat(HabitationalCertificateOfInsuranceRoutes),
      },

      //----------------------------LIFE INSURANCE POLICY ------------------------------
      {
        path: "/life-insurance-policy/:customerId",
        element: (
          <AuthorizedRoute
            allowFullAccess={true}
            moduleKeys={[MODULE_IDS.LIFE_AND_FINCANCIAL]}
          >
            <LifeInsurancePolicyLayout />
          </AuthorizedRoute>
        ),
        children: [
          {
            path: "/life-insurance-policy/:customerId/basic-details/",
            exact: true,
            element: (
              <AuthorizedRoute
                allowFullAccess={true}
                moduleKeys={
                  [
                    // MODULE_IDS.LIFE_AND_FINCANCIAL,
                    // MODULE_IDS.LIFE_AND_FINCANCIAL_POLICY_ADMIN_MANAGER,
                  ]
                }
              >
                <LifeInsuranceBasicDetails />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/life-insurance-policy/:customerId/basic-details/:customerPolicyId",
            element: (
              <AuthorizedRoute
                allowFullAccess={true}
                moduleKeys={
                  [
                    // MODULE_IDS.LIFE_AND_FINCANCIAL,
                    // MODULE_IDS.LIFE_AND_FINCANCIAL_POLICY_ADMIN_MANAGER,
                  ]
                }
              >
                <LifeInsuranceBasicDetails />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/life-insurance-policy/:customerId/family-tree/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute
                allowFullAccess={true}
                moduleKeys={
                  [
                    // MODULE_IDS.LIFE_AND_FINCANCIAL
                  ]
                }
              >
                <LifeInsuranceFamilyTreeExistingList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/life-insurance-policy/:customerId/family-tree/:customerPolicyId/family",
            exact: true,
            element: (
              <AuthorizedRoute
                allowFullAccess={true}
                moduleKeys={
                  [
                    // MODULE_IDS.LIFE_AND_FINCANCIAL
                  ]
                }
              >
                <LifeInsuranceFamilyTreeExisting />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/life-insurance-policy/:customerId/family-tree/:customerPolicyId/family/:familyNo",
            exact: true,
            element: (
              <AuthorizedRoute
                allowFullAccess={true}
                moduleKeys={
                  [
                    // MODULE_IDS.LIFE_AND_FINCANCIAL
                  ]
                }
              >
                <LifeInsuranceFamilyTreeExisting />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/life-insurance-policy/:customerId/coverage-needs-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute
                allowFullAccess={true}
                moduleKeys={
                  [
                    // MODULE_IDS.LIFE_AND_FINCANCIAL
                  ]
                }
              >
                <LifeInsuranceCoverageNeedList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/life-insurance-policy/:customerId/coverage-needs-tab/:customerPolicyId/create",
            exact: true,
            element: (
              <AuthorizedRoute
                allowFullAccess={true}
                moduleKeys={
                  [
                    // MODULE_IDS.LIFE_AND_FINCANCIAL
                  ]
                }
              >
                <LifeInsuranceCoverageNeed />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/life-insurance-policy/:customerId/coverage-needs-tab/:customerPolicyId/:incremental_number",
            exact: true,
            element: (
              <AuthorizedRoute
                allowFullAccess={true}
                moduleKeys={
                  [
                    // MODULE_IDS.LIFE_AND_FINCANCIAL
                  ]
                }
              >
                <LifeInsuranceCoverageNeed />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/life-insurance-policy/:customerId/history-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.LIFE_AND_FINCANCIAL]}>
                <LifeInsuranceHistory />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/life-insurance-policy/:customerId/attachment-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute
                allowFullAccess={true}
                moduleKeys={
                  [
                    // MODULE_IDS.LIFE_AND_FINCANCIAL
                  ]
                }
              >
                <LifeInsuranceAttachmentList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/life-insurance-policy/:customerId/activity-task-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.LIFE_AND_FINCANCIAL]}>
                <LifeInsuranceTask />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/life-insurance-policy/:customerId/compliance-checklist-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute
                allowFullAccess={true}
                moduleKeys={
                  [
                    // MODULE_IDS.LIFE_AND_FINCANCIAL
                  ]
                }
              >
                <LifeInsuranceComplianceCheckList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/life-insurance-policy/:customerId/additional-information-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.LIFE_AND_FINCANCIAL]}>
                <LifeInsuranceAdditionalInformationRoot />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/life-insurance-policy/:customerId/claims-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute
                allowFullAccess={true}
                moduleKeys={
                  [
                    // MODULE_IDS.LIFE_AND_FINCANCIAL
                  ]
                }
              >
                <LifeInsurerClaim />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/life-insurance-policy/:customerId/task-activity-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute
                allowFullAccess={true}
                moduleKeys={
                  [
                    // MODULE_IDS.LIFE_AND_FINCANCIAL
                  ]
                }
              >
                <LifeInsuranceTaskActivity />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/life-insurance-policy/:customerId/task-activity-tab/:customerPolicyId/tasks",
            exact: true,
            element: (
              <AuthorizedRoute
                allowFullAccess={true}
                moduleKeys={
                  [
                    // MODULE_IDS.ALL_TASK
                  ]
                }
              >
                <CreateTasks
                  fromPolicy
                  policyType={POLICIES.LIFE_AND_FINCANCIAL_POLICY}
                />
              </AuthorizedRoute>
            ),
          },

          {
            path: "/life-insurance-policy/:customerId/task-activity-tab/:customerPolicyId/tasks/:taskCode",
            exact: true,
            element: (
              <AuthorizedRoute
                allowFullAccess={true}
                moduleKeys={
                  [
                    // MODULE_IDS.ALL_TASK
                  ]
                }
              >
                <CreateTasks
                  fromPolicy
                  policyType={POLICIES.LIFE_AND_FINCANCIAL_POLICY}
                />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/life-insurance-policy/:customerId/notes-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute
                allowFullAccess={true}
                moduleKeys={
                  [
                    // MODULE_IDS.LIFE_AND_FINCANCIAL
                  ]
                }
              >
                <LifeInsuranceNoteFormList />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/life-insurance-policy/:customerId/notes-tab/:customerPolicyId/note",
            exact: true,
            element: (
              <AuthorizedRoute
                allowFullAccess={true}
                moduleKeys={
                  [
                    // MODULE_IDS.LIFE_AND_FINCANCIAL
                  ]
                }
              >
                <LifeInsurancePolicyNoteForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/life-insurance-policy/:customerId/notes-tab/:customerPolicyId/note/:noteNumber",
            exact: true,
            element: (
              <AuthorizedRoute
                allowFullAccess={true}
                moduleKeys={
                  [
                    // MODULE_IDS.LIFE_AND_FINCANCIAL
                  ]
                }
              >
                <LifeInsurancePolicyNoteForm />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/life-insurance-policy/:customerId/policy-forms-tab/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.LIFE_AND_FINCANCIAL]}>
                <LifeInsurancePolicyFormsRoot />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/life-insurance-policy/:customerId/policy-forms-tab/:customerPolicyId/cancellation/:taskCode",
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.LIFE_AND_FINCANCIAL]}>
                <LifeInsuranceCancellation />
              </AuthorizedRoute>
            ),
          },
        ]
          .concat(LifeInsurancePolicyRouter)
          .concat(LifePolicyUpdatesRoutes)
          .concat(LifeInsuranceEmailThreadRoutes)
          .concat(LifeInsuranceSequencesRoutes),
      },
      {
        path: "/tasks",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.ALL_TASK]}>
            <CreateTasks />
          </AuthorizedRoute>
        ),
      },

      {
        path: "/tasks/:taskCode",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.ALL_TASK]}>
            <CreateTasks />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/users/view-profile/:userId",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.USERS]}>
            <ViewProfile />
          </AuthorizedRoute>
        ),
      },

      {
        path: "/insurance-reports/order-insurance-report",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.INSURANCE_REPORTS]}>
            <OrderInsuranceReport />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/insurance-reports/no-policy/:licenseNumber/:incrementalNumber",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.INSURANCE_REPORTS]}>
            <NoPolicyInsuranceReports />
          </AuthorizedRoute>
        ),
      },

      {
        path: "/create-security-group",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.ROLE_MODULE]}>
            <SecurityDashboard />
          </AuthorizedRoute>
        ),
      },

      {
        path: "/create-security-group/:roleId",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.ROLE_MODULE]}>
            <SecurityDashboard />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/secuirty-role-duplicate/:roleId",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.ROLE_MODULE]}>
            <SecurityDashboard isDuplicate />
          </AuthorizedRoute>
        ),
      },

      {
        path: "/view-insurer",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.INSURER]}>
            <ViewInsurerReport />
          </AuthorizedRoute>
        ),
      },

      {
        path: "/view-insurer-contact",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.INSURER_CONTACTS]}>
            <ViewInsurerContactList />
          </AuthorizedRoute>
        ),
      },

      {
        path: "/recievable",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
            <AccountingRecievableTabs />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/create-recievable",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
            <AccountingRecievable />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/trust",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
            <AccountingRecievableTrust />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/trust/:incrementalNumber",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
            <AccountingRecievableTrust />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/create-eft",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
            <AccountingEft />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/create-account-payable",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
            <AccountingAccountPayable />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/create-interac-email-transfer",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
            <AccountingInteracEmailTransfer />
          </AuthorizedRoute>
        ),
      },

      {
        path: "/transaction-list",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
            <AccountingTransactionList />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/transaction/create",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
            <AccountingTransactions />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/information-list",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
            <AccountingInformationList />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/information/create",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
            <AccountingInformation />
          </AuthorizedRoute>
        ),
      },

      {
        path: "/bill/payment/history/:billId",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
            <BillPaymentHistoryView />
          </AuthorizedRoute>
        ),
      },

      {
        path: "/payment",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
            <AccountingPaymentTabs />
          </AuthorizedRoute>
        ),
      },

      {
        path: "/notes-list",
        exact: true,
        element: (
          <AuthorizedRoute
            allowFullAccess
            moduleKeys={[MODULE_IDS.TASK_ACTIVITIES]}
          >
            {/* <TaskNotesList /> */}
            <NewTaskNotesList />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/task-approvals",
        exact: true,
        element: (
          <AuthorizedRoute
            allowFullAccess
            moduleKeys={[MODULE_IDS.TASK_APPROVALS]}
          >
            <TaskApprovalList />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/manage-note",
        exact: true,
        element: (
          <AuthorizedRoute allowFullAccess moduleKeys={[]}>
            <ManageTaskNote />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/manage-note/:customerPolicyId/:noteId",
        exact: true,
        element: (
          <AuthorizedRoute allowFullAccess moduleKeys={[]}>
            <ManageTaskNote />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/premium-finance",
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_PREMIMUM_FINANCE]}>
            <PremiumFinanceForTaskTab />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/decode-vin",
        exact: true,
        element: (
          <AuthorizedRoute allowFullAccess moduleKeys={[]}>
            <DecodeVin />
          </AuthorizedRoute>
        ),
      },
      { ...emailRoutes },

      { path: "access", element: <AccessDenied /> },
      { path: "error", element: <OOPSError /> },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ]
      .concat(leadsRoutes)
      .concat(followUpsRoutes)
      .concat(g4SignRoutes)
      .concat(EmailStatisticsRoutes)
      .concat(OpportunitesRoutes)
      .concat(legalRoutes)
      .concat(appFormRoutes)
      .concat(equipmentRoutes)
      .concat(ProjectRoutes)
      .concat(UserMappingRoutes)
      .concat(ImportBillPaymentsRoutes)
      .concat(ImportInvoicePaymentsRoutes)
      .concat(fileUploadWithAIRouter)
      .concat(policyChangeRequestRoutes)
      .concat(DashboardRoutes)
      .concat(qoutesRoutes)
      .concat(eventsRoutes)
      .concat(accountReceivableReports)
      .concat(insuranceCompanyRoutes)
      .concat(TaxReportsRouter)
      .concat(AccountPayableReportRouter)
      .concat(CustomersRoutes)
      .concat(automationRoutes)
      .concat(emailSequencesRoutes)
      .concat(utilityRoutes)
      .concat(accessLogsRoutes)
      .concat(EnvConfigRoutes)
      .concat(QuoteRoutes)
      .concat(securityRoutes)
      .concat(TemplatesRoutes)
      .concat(AccountingRoutes)
      .concat(ReportsRoutes)
      .concat(ReconciliationRoutes)
      .concat(supportTicketsRoutes)
      .concat(UsersRoutes)
      .concat(StaffDirectoryRoutes)
      .concat(OnBoardingRoutes)
      .concat(csioCronRoutes)
      .concat(CSIORoutes)
      .concat(csioEdocsRoutes)
      .concat(csioEDIRoutes)
      .concat(taskRoutes)
      .concat(noticesRoutes)
      .concat(claimsRoutes)
      .concat(EmailsRoutes)
      .concat(RIBOFormsRoutes)
      .concat(masterDropdownsRoutes)
      .concat(customFormFieldsRoutes)
      .concat(dynamicFormTemplatesRoutes)
      .concat(myCommissionReportsRoutes)
      .concat(myStatementsRoutes)
      .concat(policyOptionsRoutes)
      .concat(dashboardSettingsRoutes)
      .concat(notificationsRoutes)
      .concat(operationalUpdatesRoutes)
      .concat(signatureRoutes)
      .concat(genAiKnowledgeBaseRoutes)
      .concat(phoneRoutes as any)
      .concat(webrtcDiagnosticsRoutes as any)
      .concat(emailRoutes)
      .concat(whatsAppRoutes)
      .concat(externalLeadsRoutes)
      .concat(genAiRoutes)
      .concat(MessageSequenceRoutes)
      .concat(
        isMirtapbxCallLinkingEnabled() ? [...mirtapbxRoutes] : [],
      )
  },

  // --------------------------------TASK ROUTING----------------------------------------------

  {
    path: "/auth",
    element: (
      <PublicRoute>
        <BlankLayout />
      </PublicRoute>
    ),
    children: [
      { path: "404", element: <Error /> },
      { path: "login", element: <Login /> },
      { path: "reset-password", element: <ForgotPassword /> },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: "hr-application",
    element: (
      <PublicRoute>
        <BlankLayout />
      </PublicRoute>
    ),
    children: [
      { path: "", element: <HrApplication /> }, // ✅ Publicly accessible form
      { path: "thank-you", element: <ThankYou /> },
    ],
  },
  {
    path: "lead-form",
    element: (
      <PublicRoute>
        <BlankLayout />
      </PublicRoute>
    ),
    children: [
      { path: "", element: <PublicLeadForm /> }, // ✅ Publicly accessible lead form
      { path: "thank-you", element: <LeadThankYou /> },
    ],
  },
  {
    path: "policy-updates/:key",
    element: (
      <PublicRoute>
        <BlankLayout />
      </PublicRoute>
    ),
    children: [
      { path: "", element: <PublicPolicyUpdatesForm /> }, // ✅ Publicly accessible form
      { path: "thank-you", element: <ThankYou /> },
    ],
  },

  {
    path: "/other",
    element: <BlankLayout />,
    children: [
      { path: "user-access", element: <OtherUserLogin /> },
      { path: "404", element: <Error /> },
      { path: "login", element: <Login /> },
      { path: "reset-password", element: <ForgotPassword /> },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
];
